export enum DialogsFilterType {
  Chats = 'chats',
  Deals = 'deals',
  Favorites = 'favorites',
}
